module.exports = __webpack_public_path__ + "static/Srinivasa-1-e3649f92701748ecdb4c16f34f5bc1fd.jpeg";